import React from "react";
import Link from "ui/Link";
import { SurfaceType } from "utils/analytics/analyticsConstants";
import ShockedFaceSVG from "images/shocked_face.svg";
import { HelpLinks } from "utils/helpLinks";
import styled from "styled-components/macro";
import Modal from "ui/eds/Modal";
import { theme } from "ui/theme";
import VisibilityTracker from "ui/VisibilityTracker";
import Typography from "ui/Typography";
import Button from "ui/Button";

interface ErrorModalProps {
  /**
   * The surface to use for the `viewed_generic_error_modal` event.
   * If left undefined it will use the value within the analytic context.
   */
  analyticsSurface?: SurfaceType;
  onClose?: () => void;
  show: boolean;
}

const $ErrorIcon = styled.img`
  display: block;
  margin: 0 auto 2rem auto;
`;

const $ModalTitleWrapper = styled(Modal.Title)`
  margin: 2rem 1.5rem 0rem 1.5rem;
  text-align: center;
`;

const $ModalTitle = styled(Typography).attrs({
  size: "h3",
  forwardedAs: "div",
})`
  font-size: ${theme.SizeXl};
`;

const $MessageWrapper = styled.div`
  margin: 1rem 1rem 2rem 1rem;
`;

const $PrimaryButton = styled(Button)`
  min-width: 15rem;
`;

export default function ErrorModal({
  analyticsSurface,
  onClose,
  show,
}: ErrorModalProps) {
  const closeButtonProps = {
    onClick: onClose ? onClose : () => {},
    analyticsName: "clicked_close",
    analyticsSurface: SurfaceType.GENERIC_ERROR_MODAL,
  };

  return (
    <Modal
      open={show}
      close={closeButtonProps}
      aria-label="Error Pop-up"
      overrideSize="standard"
    >
      <$ModalTitleWrapper>
        <VisibilityTracker analyticsName="clicked_create_zendesk_ticket">
          <>
            <$ErrorIcon src={ShockedFaceSVG} alt="" />
            <$ModalTitle>Oops! We’re having an issue.</$ModalTitle>
          </>
        </VisibilityTracker>
      </$ModalTitleWrapper>
      <Modal.Body className="text-center">
        <$MessageWrapper>
          Try{" "}
          <Link
            analyticsName="clicked_refresh"
            analyticsSurface={SurfaceType.GENERIC_ERROR_MODAL}
            onClick={() => window.location.reload()}
          >
            refreshing the page
          </Link>{" "}
          or checking back later
        </$MessageWrapper>
        <$PrimaryButton
          href={HelpLinks.NEW_REQUEST}
          analyticsName="clicked_create_zendesk_ticket"
          analyticsSurface={analyticsSurface || SurfaceType.GENERIC_ERROR_MODAL}
          requestInProgress={false}
        >
          Contact support
        </$PrimaryButton>
      </Modal.Body>
    </Modal>
  );
}
